import { gql } from '@apollo/client';
import { ADDRESS_FIELDS } from '../address';
import { BILLING_FIELDS } from '../billing';
import { CLIENT_FIELDS } from './client.fields';

export const CLIENT_DETAIL_FIELDS = gql`
  ${ADDRESS_FIELDS}
  ${BILLING_FIELDS}
  ${CLIENT_FIELDS}
  fragment ClientDetailFields on Client {
    ...ClientFields
    address {
      ...AddressFields
    }
    billings {
      ...BillingFields
    }
  }
`;
